import { Amplify } from 'aws-amplify';

const isConfigured = { current: false };

if (!isConfigured.current) {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID || 'us-east-1_aZ5embKsw',
        userPoolClientId: import.meta.env.VITE_COGNITO_CLIENT_ID || '3hsa5r05aj844k7sdj544fcs',
        loginWith: {
          email: true,
        },
      },
    },
  });
  isConfigured.current = true;
}

export function AmplifyInit() {
  // This component exists solely to ensure the Amplify import + config
  // runs on every page load. It renders nothing.
  return null;
}
